export const RESET = 'PRODUCTSTATUS_LIST_RESET'
export const SET_ITEMS = 'PRODUCTSTATUS_LIST_SET_ITEMS'
export const SET_ERROR = 'PRODUCTSTATUS_LIST_SET_ERROR'
export const SET_VIEW = 'PRODUCTSTATUS_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'PRODUCTSTATUS_LIST_TOGGLE_LOADING'
